export const BASE_URL = "https://letsenjoytourplanners.com/letsenjoy_api/";
export const BASE_URL_ADMIN =
  "https://letsenjoytourplanners.com/letsenjoy_api/admin_apis/";

// export const BASE_URL = "http://localhost/letsenjoy_api/";
// export const BASE_URL_ADMIN = "http://localhost/letsenjoy_api/admin_apis/";
